import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError, buildQuery } from '@/views/skud/shared/modules/skud-http'

export class SkudCardEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // params: from,to,issuer,state,card_uid,subject_ref,group_ref,limit — все опциональны.
  // placeId не задан -> client-scope GET /cards. -> {items} или null.
  async getCards (placeId, params) {
    const seg = placeId ? 'places/' + placeId + '/' : ''
    const res = await this.webApi.get(this.url + seg + 'cards?' + buildQuery(params || {}))
    this.lastError = res
    return unwrapEnvelope(res)
  }

  // Одна карта + субъект. -> объект или null.
  async getCredential (placeId, credentialId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/cards/credentials/' + credentialId)
    this.lastError = res
    return unwrapEnvelope(res)
  }

  // Блокировка (state=2) / разблокировка (state=0) отдельной карты.
  // -> {ok: true, data: {revision}} | {ok: false, error}
  async setCredentialState (placeId, credentialId, state) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/cards/credentials/' + credentialId + '/state', { state: state })
    const data = unwrapEnvelope(res)
    if (data) return { ok: true, data: data }
    return { ok: false, error: envelopeError(res) || 'Ошибка при изменении состояния карты' }
  }

  // PNG QR карты — сырые байты без конверта, поэтому raw fetch, а не WebApi.
  // Бизнес-ошибки Charon приходят HTTP 200 с конвертом error=true (api_doc §1.6),
  // поэтому успех определяем по content-type, а не по res.ok.
  // -> {ok: true, url: objectURL} | {ok: false, error}
  async getCardQr (placeId, cardUidHex) {
    try {
      const url = this.url + 'places/' + placeId + '/cards/qr?cardUidHex=' + encodeURIComponent(cardUidHex)
      const res = await fetch(url, { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } })
      if ((res.headers.get('content-type') || '').includes('image/')) {
        return { ok: true, url: URL.createObjectURL(await res.blob()) }
      }
      const body = await res.json().catch(() => null)
      return { ok: false, error: envelopeError(body) || ('HTTP ' + res.status) }
    } catch (e) {
      return { ok: false, error: String(e) }
    }
  }
}
